import { Component, Input, OnInit, OnDestroy, Inject, PLATFORM_ID, ChangeDetectionStrategy, OnChanges, SimpleChanges, signal, computed, effect } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-call-to-action-with-countdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './call-to-action-with-countdown.component.html',
  styleUrls: ['./call-to-action-with-countdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallToActionWithCountdownComponent implements OnInit, OnDestroy, OnChanges {
  @Input() data: any;
  
  // Signals voor countdown state
  private timeDifferenceSignal = signal(0);
  
  // Computed signals voor countdown values
  countdown = computed(() => {
    const timeDiff = this.timeDifferenceSignal();

    if (timeDiff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    
    const result = {
      days: Math.floor(timeDiff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((timeDiff % (1000 * 60)) / 1000)
    };

    return result;
  });
  
  private countdownInterval: NodeJS.Timeout | null = null;
  private isBrowser: boolean;
  
  constructor(
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  
  ngOnInit() {
    this.initializeCountdown();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && changes['data'].currentValue) {
      this.initializeCountdown();
    }
  }

  private initializeCountdown() {
    // Stop any existing countdown
    this.stopCountdown();
    
    // Always calculate initial values first
    this.updateCountdown();
    
    // Only start countdown in browser environment
    if (this.isBrowser && this.data?.date) {
      this.startCountdown();
    }
  }
  
  ngOnDestroy() {
    this.stopCountdown();
  }
  
  private startCountdown() {
    if (!this.isBrowser || !this.data?.date) {
      return;
    }
    
    this.updateCountdown();
    
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }
  
  private stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }
  
  private updateCountdown() {
    try {
      if (!this.data?.date) {
        console.warn('[Countdown] No date provided:', this.data);
        return;
      }

      const targetDate = new Date(this.data.date);
      const currentDate = new Date();

      // Check if date is valid
      if (isNaN(targetDate.getTime())) {
        console.warn('[Countdown] Invalid date provided:', this.data.date);
        this.stopCountdown();
        return;
      }

      const timeDifference = targetDate.getTime() - currentDate.getTime();

      if (timeDifference <= 0) {
        this.timeDifferenceSignal.set(0);
        this.stopCountdown();
        return;
      }

      // Update signal met nieuwe tijd
      this.timeDifferenceSignal.set(timeDifference);
    } catch (error) {
      
      this.stopCountdown();
    }
  }
}
